/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { TransactionSummaryViewModel } from './TransactionSummaryViewModel';
import {
    TransactionSummaryViewModelFromJSON,
    TransactionSummaryViewModelFromJSONTyped,
    TransactionSummaryViewModelToJSON,
} from './TransactionSummaryViewModel';

/**
 * 
 * @export
 * @interface ResultOfTransactionSummaryViewModel
 */
export interface ResultOfTransactionSummaryViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {TransactionSummaryViewModel}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    data?: TransactionSummaryViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTransactionSummaryViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfTransactionSummaryViewModel interface.
 */
export function instanceOfResultOfTransactionSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfTransactionSummaryViewModelFromJSON(json: any): ResultOfTransactionSummaryViewModel {
    return ResultOfTransactionSummaryViewModelFromJSONTyped(json, false);
}

export function ResultOfTransactionSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfTransactionSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : TransactionSummaryViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfTransactionSummaryViewModelToJSON(value?: ResultOfTransactionSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': TransactionSummaryViewModelToJSON(value.data),
        'Count': value.count,
    };
}

